<template>
  <div
    v-if="sidebarItems"
    :class="['sidebar-wrap', !isCollapsed && 'show']"
  >
    <b-button
      class="collapsed-button"
      variant="link"
      @click="toggleSideBar"
    >
      <font-awesome-icon :icon="isCollapsed ? 'chevron-right': 'chevron-left'" />
    </b-button>
    <div
      v-if="!isCollapsed"
      class="sidebar"
    >
      <div class="sticky-header">
        <b-form-input
          v-model="searchKeyword"
          class="search-input"
          type="text"
          placeholder="Search"
          data-test="search-input"
          debounce="500"
        />
      </div>
      <nav
        class="menu"
        data-test="menu"
      >
        <div v-if="filteredItems().general.length">
          <ul
            class="menu-list"
            data-test="general-menu-list"
          >
            <sidebar-item
              v-for="(menuItem, index) in filteredItems().general"
              :key="index"
              data-test="mdm-menu-item"
              :item="menuItem"
              :search-value="searchKeyword"
              :is-search-value-exist="!!searchKeyword.length"
            />
          </ul>
        </div>
        <div v-if="filteredItems().systems.length">
          <h4
            class="menu-section-title"
            data-test="system-modules-title"
            @click="showSystemModules = !showSystemModules"
          >
            <span v-if="!isCollapsed">System modules</span>
            <b-button
              variant="outline"
              size="sm"
            >
              <font-awesome-icon
                icon="chevron-down"
                :class="['chevron', showSystemModules && 'opened']"
              />
            </b-button>
          </h4>
          <ul
            v-if="showSystemModules"
            class="menu-list"
            data-test="system-menu-list"
          >
            <sidebar-item
              v-for="(menuItem, index) in filteredItems().systems"
              :key="index"
              :item="menuItem"
              data-test="system-menu-item"
              :search-value="searchKeyword"
              :is-search-value-exist="!!searchKeyword.length"
            />
          </ul>
        </div>
        <div v-if="filteredItems().noSystems.length">
          <h4
            class="menu-section-title"
            data-test="mdm-modules-title"
            @click="showMDMModules = !showMDMModules"
          >
            <span v-if="!isCollapsed">MDM modules</span>
            <b-button
              variant="outline"
              size="sm"
            >
              <font-awesome-icon
                icon="chevron-down"
                :class="['chevron', showMDMModules && 'opened']"
              />
            </b-button>
          </h4>
          <ul
            v-if="showMDMModules"
            class="menu-list"
            data-test="mdm-menu-list"
          >
            <sidebar-item
              v-for="(menuItem, index) in filteredItems().noSystems"
              :key="index"
              data-test="mdm-menu-item"
              :item="menuItem"
              :search-value="searchKeyword"
              :is-search-value-exist="!!searchKeyword.length"
            />
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
  
  
<script>
import SidebarItem from './SidebarItem';
  
import {createNamespacedHelpers} from 'vuex';
import {transformData} from '@/store/modules/sidebar-configuration/actions';
  
const {mapGetters, mapActions} = createNamespacedHelpers('app');
const {mapState: userMapState, mapActions: mapActionsUser} = createNamespacedHelpers('user');
const {
  mapActions: mapActionsSidebar,
  mapState: mapStateSidebar,
} = createNamespacedHelpers('sidebar');
  
export default {
  name: 'SidebarOld',
  components: {
    SidebarItem,
  },
  data: () => {
    return {
      searchKeyword: '',
      showSystemModules: false,
      showMDMModules: true,
      isCollapsed: false,
    };
  },
  computed: {
    ...userMapState({
      currentUserPermission: state => state.currentUserAdpPermission.data.role,
    }),
    ...mapStateSidebar({
      sidebarItems: state => state.menuItems,
      foldersExceptions: state => state.foldersListWithExceptions,
    }),
  },
  methods: {
    ...mapActions(['toggleMenuCollapse']),
    ...mapActionsSidebar(['getSidebarStructure', 'transformData']),
    ...mapActionsUser(['getUserAdGroups']),
    toggleSideBar() {
      this.isCollapsed = !this.isCollapsed;
    },
    filteredItems() {
      if (!this.sidebarItems) return;
  
      const searchKeyword = this.searchKeyword.toString().toLowerCase();
      const isSearchValueExist = !!searchKeyword.length;
      const backupMenuItems = JSON.parse(JSON.stringify(this.sidebarItems));
  
      function searchRecursive(item) {
        const matchesSearchTerm = item.label.toLowerCase().includes(searchKeyword) ;
        if(item.label === 'Loan Calculator' && isSearchValueExist && matchesSearchTerm) {
          return;
        }
        let hasVisibleChildren = false;
        if (item.children) {
          item.children = item.children
            .filter(child => searchRecursive(child))
            .map(child => ({...child, isOpen: isSearchValueExist }));
          hasVisibleChildren = item.children.length > 0;
        }
        return matchesSearchTerm || hasVisibleChildren;
      }
  
      const filteredMenuItems =  backupMenuItems
        .filter((item) => searchRecursive(item))
        .map((item) => ({...item, isOpen: isSearchValueExist}))
        .sort((a, b) => a.sortOrder - b.sortOrder);
      
      return transformData(
        filteredMenuItems,
        isSearchValueExist,
        this.foldersExceptions,
      );
    },
  },
  created() {
    this.getUserAdGroups();
  },
  async beforeMount() {
    if (!this.sidebarItems) {
      await this.getSidebarStructure();
    }
  },
};
</script>
  
  <style scoped lang="scss">
  
  .menu, .ps {
    max-height: 90vh;
    width: 248px;
    overflow-y: auto;
  
    ul {
      margin-bottom: 0;
      list-style: none;
      padding-left: 0 !important; ;
      margin-left: 0 !important;
    }
  }
  
  .sidebar-wrap {
    border-right: 2px solid #d5d5d5;
    background-color: #fff;
    height: 100%;
  }
  
  .sidebar {
    display: flex;
    flex-direction: column;
  }
  
  .sticky-header {
    flex-shrink: 0;
    padding:0px;
  }
  
  .search-input {
    border-radius: unset;
    display: block;
    height: 42px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  
    &:focus {
      border-color: unset;
    }
  }
  
  .collapsed-button {
    position: absolute;
    top: 50%;
    right: -17px;
    transform: translateY(-50%);
    z-index: 1000;
    padding: 5px 2px;
    border: none;
    background: #0F355E;
    color: #fff;
    font-size: 18px;
    transition: all 0.3s;
    border-radius: 2px;
  
    &:hover {
      background-color: #285291;
      color: white;
    }
  }
  
  .menu-section-title {
    margin: 0;
    padding: 5px 15px;
    background-color: #0F355E;
    color: white;
    cursor: pointer;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: 0.3s;
  
    &:first-child {
      border-bottom: 1px solid white;
    }
  
    &:hover {
      background-color: #285291;
    }
  }
  
  .btn .btn:focus, .clear__btn {
    box-shadow: none;
    color: white;
  }
  
  .chevron {
    color: white;
    transition: 0.3s;
  
    &.opened {
      transform: rotate(-180deg);
    }
  }
  
  </style>
  